/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { Loading } from '@brands/Components/LoadingSpinner/Loading';
import PatientIntakeNavigation from '@brands/Components/PatientIntakeNavigation/PatientIntakeNavigation';
import RemoveItemModal from '@brands/Dashboard/Dashboard/Components/RemoveItemModal/RemoveItemModal';
import AddPharmacy from '@brands/Dashboard/Pharmacy/Components/AddPharmacy';
import SearchForPharmacy from '@brands/Dashboard/Pharmacy/Components/FindPharmacy';
import { PharmacySubmit } from '@brands/Dashboard/Pharmacy/Components/types';
import { useWindowSize } from '@brands/hooks';
import { useAppSelector } from '@brands/hooks/useReduxHook';
import useRoleNavigate from '@brands/hooks/useRoleNavigate';
import { useSnackbar } from '@brands/hooks/useStackbar';
import { CaseType } from '@brands/services/cases/types/ICase';
import { addClinicalData } from '@brands/services/clinical_data/addClinicalData';
import { listClinicalData } from '@brands/services/clinical_data/listClinicalData';
import { MedicalHistory } from '@brands/services/clinical_data/types/types';
import { updateClinicalData } from '@brands/services/clinical_data/updateClinicalData';
import { UserRoleName } from '@brands/services/identity/types/UserProfile';
import { selectAuth } from '@brands/store/selectors/auth';
import { selectStaffCaseCreation } from '@brands/store/selectors/staffCaseCreation';
import { selectPatientForm } from '@brands/store/selectors/patientForm';
import { selectPatient } from '@brands/store/selectors/selectedPatient';
import GenericSnackbar from '@brands/Utils/GenericSnackbar';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { Button } from '@mui/material';
import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import Container from '../../../../Components/Container/Container';
import styles from './styles.module.scss';

const nonPharmacyMedicalHistoryFields = (mh: MedicalHistory | null | undefined) => ({
  under_care_of_physician: mh?.under_care_of_physician ?? null,
  conditions_treated: mh?.conditions_treated ?? null,
  taking_medication: mh?.taking_medication ?? null,
  medications: mh?.medications ?? null,
  allergic_to_medications: mh?.allergic_to_medications ?? null,
  medications_allergies: mh?.medications_allergies ?? null,
  using_substances: mh?.using_substances ?? [],
  interested_in_stopping: mh?.interested_in_stopping ?? null,
  height: mh?.height ?? '',
  weight: mh?.weight ?? '',
  height_cm: mh?.height_cm ?? null,
  weight_kg: mh?.weight_kg ?? null,
  height_unit: mh?.height_unit,
  weight_unit: mh?.weight_unit,
});

const SelectPharmacy = (): JSX.Element => {
  const screenSize = useWindowSize();
  const { userInfo } = useAppSelector(selectAuth);
  const { selectedPatient } = useAppSelector(selectPatientForm);
  const selectedPatientId = selectedPatient?.value;
  const { selectedPatient: currentPatient } = useAppSelector(selectPatient);
  const { isStaffIntake } = useAppSelector(selectStaffCaseCreation);
  const isCollectorPharmacyApiContext = isStaffIntake && userInfo?.role?.name === UserRoleName.Collector;
  const targetUserId =
    isCollectorPharmacyApiContext && currentPatient?.id ? Number(currentPatient.id) : Number(userInfo.id);
  const apiRole = isCollectorPharmacyApiContext ? UserRoleName.Collector : undefined;
  const [render, setRender] = useState(false);
  const [pharmacyName, setPharmacyName] = useState('');
  const [pharmacyAddress, setPharmacyAddress] = useState('');
  const [pharmacyPhoneNumber, setPharmacyPhoneNumber] = useState('');
  const [findPharmacy, setFindPharmacy] = useState(false);
  const [addPharmacy, setAddPharmacy] = useState(false);
  const [objectId, setObjectId] = useState<string | null>(null);
  const [dependentObjectId, setDependentObjectId] = useState<string | null>(null);
  const [medicalHistory, setMedicalHistory] = useState<MedicalHistory | null>(null);
  const [dependentMedicalHistory, setDependentMedicalHistory] = useState<MedicalHistory | null>(null);
  const [removeItemModal, setRemoveItemModal] = useState(false);
  const { values } = useAppSelector(selectPatientForm);
  const { snackbar, showSnackbar, closeSnackbar } = useSnackbar();
  const [selectedPharmacy, setSelectedPharmacy] = useState<PharmacySubmit>();
  const roleNavigate = useRoleNavigate();
  const navigate = useNavigate();
  const AddNewPharmacy = (newPharmacy: PharmacySubmit): void => {
    setSelectedPharmacy(newPharmacy);
  };

  const AddNewPharmacySubmit = async (newPharmacy: PharmacySubmit): Promise<void> => {
    try {
      if (!objectId) {
        await addClinicalData('medical_history', {
          user_id: targetUserId,
          under_care_of_physician: null,
          conditions_treated: null,
          taking_medication: null,
          medications: null,
          allergic_to_medications: null,
          medications_allergies: null,
          using_substances: [],
          interested_in_stopping: null,
          height: '',
          weight: '',
          pharmacy_name: newPharmacy.pharmacy_name,
          pharmacy_street_address: newPharmacy.pharmacy_street_address,
          pharmacy_city: newPharmacy.pharmacy_city,
          pharmacy_state: newPharmacy.pharmacy_state,
          pharmacy_zip_code: newPharmacy.pharmacy_zip_code,
          pharmacy_phone_number: newPharmacy.pharmacy_phone_number,
        }, apiRole);
      } else {
        await updateClinicalData(
          'medical_history',
          objectId,
          { ...nonPharmacyMedicalHistoryFields(medicalHistory), ...newPharmacy },
          apiRole,
        );
        if (targetUserId !== Number(selectedPatientId) && dependentObjectId) {
          await updateClinicalData(
            'medical_history',
            dependentObjectId,
            { ...nonPharmacyMedicalHistoryFields(dependentMedicalHistory), ...newPharmacy },
            apiRole,
          );
        }
      }
      await getFormAnswers(targetUserId, apiRole);
      setAddPharmacy(false);
      // setFindPharmacy(false);
      // showSnackbar(`Youâ€™ve successfully added ${newPharmacy.pharmacy_name} to your saved pharmacies`, 'success');
      if ((values.find((item) => item.form_question_id === 20)?.value.caseType as string) === CaseType.second_opinion) {
        roleNavigate('/upload-image');
      } else roleNavigate('/describe-pain-level');
    } catch (error) {
      showSnackbar(`Error: ${error}`, 'error');
    }
  };

  const removePharmacy = async (): Promise<void> => {
    if (objectId) {
      await updateClinicalData('medical_history', objectId, {
        ...nonPharmacyMedicalHistoryFields(medicalHistory),
        pharmacy_name: '',
        pharmacy_street_address: '',
        pharmacy_city: '',
        pharmacy_state: '',
        pharmacy_zip_code: '',
        pharmacy_phone_number: '',
      }, apiRole);
      if (targetUserId !== Number(selectedPatientId) && dependentObjectId) {
        await updateClinicalData('medical_history', dependentObjectId, {
          ...nonPharmacyMedicalHistoryFields(dependentMedicalHistory),
          pharmacy_name: '',
          pharmacy_street_address: '',
          pharmacy_city: '',
          pharmacy_state: '',
          pharmacy_zip_code: '',
          pharmacy_phone_number: '',
        }, apiRole);
      }
      await getFormAnswers(targetUserId, apiRole);
      setRemoveItemModal(false);
    }
  };

  const getFormAnswers = useCallback(async (createdByPatientId: number | undefined, role?: string) => {
    setRender(false);
    try {
      const { medical_history } = await listClinicalData(createdByPatientId ?? 0, role);
      setMedicalHistory(medical_history ?? null);
      if (medical_history) {
        setObjectId(medical_history.id.toString());

        if (targetUserId !== Number(selectedPatientId) && selectedPatientId) {
          const { medical_history: dependent_medical_history } = await listClinicalData(Number(selectedPatientId), role);
          setDependentMedicalHistory(dependent_medical_history ?? null);
          if (dependent_medical_history) {
            setDependentObjectId(dependent_medical_history.id.toString());
            await updateClinicalData('medical_history', dependent_medical_history.id.toString(), {
              ...nonPharmacyMedicalHistoryFields(dependent_medical_history),
              pharmacy_name: medical_history?.pharmacy_name || '',
              pharmacy_street_address: medical_history?.pharmacy_street_address || '',
              pharmacy_city: medical_history?.pharmacy_city || '',
              pharmacy_state: medical_history?.pharmacy_state || '',
              pharmacy_zip_code: medical_history?.pharmacy_zip_code || '',
              pharmacy_phone_number: medical_history?.pharmacy_phone_number || '',
            }, role);
          }
        }
      }

      setPharmacyName(medical_history?.pharmacy_name || '');

      setPharmacyAddress(
        medical_history?.pharmacy_street_address && medical_history?.pharmacy_city
          ? `${medical_history.pharmacy_street_address}\n${medical_history.pharmacy_city}, ${medical_history.pharmacy_state} ${medical_history.pharmacy_zip_code}`
          : '',
      );
      setPharmacyPhoneNumber(medical_history?.pharmacy_phone_number || '');
    } finally {
      setRender(true);
    }
  }, [selectedPatientId, targetUserId]);

  useEffect(() => {
    (async () => {
      setPharmacyAddress('');

      await getFormAnswers(targetUserId, apiRole);
    })();
  }, [apiRole, getFormAnswers, targetUserId]);

  return (
    <>
      {render || addPharmacy ? (
        <Container
          isVisibleOnMobile
          isSidenavVisible={false}
          isIntakeProcess
          containerStyle={{
            justifyContent: screenSize.width >= 564 ? 'center' : 'start',
          }}
          childrenStyle={{
            zIndex: '2',
            paddingTop: screenSize.width > 768 ? '40px' : '16px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'flex-start',
            alignSelf: 'center',
          }}
        >
          <div
            className={`${styles.pharmacyContainer} ${pharmacyName && pharmacyAddress && styles.displaySavedPharmacy}`}
          >
            <PatientIntakeNavigation progress={60} />
            <div className={styles.divClassContainer}>
              {addPharmacy ? (
                <AddPharmacy
                  setFindPharmacy={setFindPharmacy}
                  setAddPharmacy={setAddPharmacy}
                  AddNewPharmacy={AddNewPharmacy}
                  isFromPatientIntake
                />
              ) : (
                <>
                  {pharmacyName && pharmacyAddress ? (
                    <div className={`fs-exclude ${styles.pharmacyInfoDiv}`}>
                      <span className={`fs-unmask ${styles.patientIntakeh2}`} data-testid="confirm-pharmacy-title">
                        Confirm Pharmacy
                      </span>
                      <div className={`fs-exclude ${styles.pharmacyInfo}`} data-testid="saved-pharmacy-div">
                        <div className={`fs-exclude ${styles.pharmacyInfoLeft}`}>
                          <span className={styles.sectionContentRowDetailsName}>{pharmacyName}</span>
                          <span className={styles.sectionContentRowDetailsAddress} style={{ whiteSpace: 'pre-line' }}>
                            {pharmacyAddress}
                          </span>
                          {pharmacyPhoneNumber && pharmacyPhoneNumber !== '' && (
                            <span className={styles.sectionContentRowDetailsAddress} data-testid="pharmacy-phone">
                              📞 {pharmacyPhoneNumber}
                            </span>
                          )}
                        </div>
                      </div>
                      <Button
                        variant="text"
                        className={styles.useDifferentPharmacy}
                        onClick={() => setRemoveItemModal(true)}
                        data-testid="confirm-pharmacy-use-different-pharmacy"
                      >
                        Use a Different Pharmacy
                      </Button>
                    </div>
                  ) : (
                    <SearchForPharmacy
                      setFindPharmacy={setFindPharmacy}
                      setAddPharmacy={setAddPharmacy}
                      AddNewPharmacy={AddNewPharmacySubmit}
                      isFromPatientIntake
                    />
                  )}
                </>
              )}
              <div className={styles.findPharmacyFooter}>
                <Button
                  variant="text"
                  className={styles.findPharmacyFooterBack}
                  onClick={() => {
                    if (addPharmacy) {
                      setAddPharmacy(false);
                    } else navigate(-1);
                  }}
                  data-testid="confirm-pharmacy-back"
                >
                  <ArrowBackIosNewIcon />
                  Back
                </Button>
                {((pharmacyName && pharmacyAddress) || addPharmacy) && (
                  <Button
                    variant="contained"
                    className={styles.findPharmacyFooterNext}
                    type="submit"
                    data-testid="confirm-pharmacy-next"
                    onClick={() => {
                      if (selectedPharmacy) {
                        AddNewPharmacySubmit(selectedPharmacy);
                      } else if (pharmacyName && pharmacyAddress) {
                        if (
                          (values.find((item) => item.form_question_id === 20)?.value.caseType as string) ===
                          CaseType.second_opinion
                        ) {
                          roleNavigate('/upload-image');
                        } else roleNavigate('/describe-pain-level');
                      }
                    }}
                    disabled={!(pharmacyName && pharmacyAddress) && selectedPharmacy === undefined}
                  >
                    Next
                  </Button>
                )}
              </div>
            </div>
          </div>
        </Container>
      ) : (
        <Loading fullScreen />
      )}

      {removeItemModal && (
        <RemoveItemModal
          isOpen={removeItemModal}
          toggleModal={setRemoveItemModal}
          itemName={pharmacyName ?? ''}
          removeItem={removePharmacy}
        />
      )}
      <GenericSnackbar open={snackbar.isOpen} message={snackbar.message} type={snackbar.type} onClose={closeSnackbar} />
    </>
  );
};

export default SelectPharmacy;
